import { useTranslation } from "react-i18next";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { stats } from "@/mocks/homeData";

export default function Stats() {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  const cards = [
    { bg: "bg-brand", delay: 0 },
    { bg: "bg-[#9B8CB5]", delay: 0.2 },
  ];

  return (
    <section className="w-full py-12 md:py-20 bg-[#F8F7F5]">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className={`relative ${cards[index].bg} rounded-2xl p-8 md:p-12 overflow-hidden`}
              initial={{ opacity: 0, y: 60, scale: 0.95 }}
              animate={isInView ? { opacity: 1, y: 0, scale: 1 } : { opacity: 0, y: 60, scale: 0.95 }}
              transition={{ duration: 0.7, delay: cards[index].delay, ease: [0.25, 0.1, 0.25, 1] }}
            >
              <motion.div
                className="absolute top-6 right-6 md:top-8 md:right-8"
                initial={{ opacity: 0, rotate: -45 }}
                animate={isInView ? { opacity: 1, rotate: 0 } : { opacity: 0, rotate: -45 }}
                transition={{ duration: 0.5, delay: cards[index].delay + 0.3 }}
              >
                <span className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/20 rounded-full">
                  <i className="ri-arrow-right-up-line text-white text-lg" />
                </span>
              </motion.div>

              <motion.div
                className="mt-8 md:mt-4"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.6, delay: cards[index].delay + 0.2, ease: [0.25, 0.1, 0.25, 1] }}
              >
                <span className="text-6xl md:text-8xl lg:text-9xl font-serif text-white font-bold">
                  {stat.value}
                </span>
              </motion.div>

              <motion.div
                className="mt-6 md:mt-8"
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: cards[index].delay + 0.35 }}
              >
                <p className="text-xl md:text-2xl font-bold text-white">
                  {t(index === 0 ? "stats.projectsLabel" : "stats.satisfactionLabel")}
                </p>
                <p className="text-base md:text-lg text-white/80 mt-1">
                  {t(index === 0 ? "stats.projectsSublabel" : "stats.satisfactionSublabel")}
                </p>
              </motion.div>

              <motion.p
                className="mt-6 md:mt-8 text-base md:text-lg text-white/70 italic"
                initial={{ opacity: 0 }}
                animate={isInView ? { opacity: 1 } : { opacity: 0 }}
                transition={{ duration: 0.5, delay: cards[index].delay + 0.45 }}
              >
                {t(index === 0 ? "stats.projectsTagline" : "stats.satisfactionTagline")}
              </motion.p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}